import { useEffect } from "react";
import { ReactComponent as PraxisProIcon } from "../assets/icons/logo-white-bg.svg";
import { initializePostHog } from "../integrations/posthog/init";
import { PRAXIS_PLAY_EVENTS } from "../integrations/posthog/events";
import { getTenantId } from "../services/utils";

const APP_STORE_URL = "https://apps.apple.com/us/app/praxispro/id6740499765";

function isIOS(): boolean {
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/i.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 0);
}

export default function MobileBlockScreen() {
  const showAppStoreLink = isIOS();

  useEffect(() => {
    const posthog = initializePostHog();
    posthog.capture(PRAXIS_PLAY_EVENTS.MOBILE_WEB_ACCESS_BLOCKED, {
      tenant_id: getTenantId(),
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    });
  }, []);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center">
      <PraxisProIcon className="w-96 mb-10 [&_path]:fill-[#7B2928] [&_path]:stroke-[#7B2928]" />
      <h1 className="text-2xl font-semibold text-gray-900 mb-3">
        Desktop Only
      </h1>
      <p className="text-gray-600 max-w-md">
      <strong>This feature is currently available on desktop only.</strong>
      <br />
      To access it, please log in through your browser.
      </p>
      {showAppStoreLink && (
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-8 inline-flex items-center gap-2 bg-black text-white px-6 py-3 rounded-xl text-base font-medium hover:bg-gray-800 transition-colors"
        >
          <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
          </svg>
          Download on the App Store
        </a>
      )}
    </div>
  );
}
